import React, { FC } from 'react'
import cn from 'classnames'
import { STATUS_TYPE } from './StatusText.enums'
import styles from './StatusText.module.css'

type Props = {
  className?: string
  type: STATUS_TYPE
}

const getStatusTypeClassName = (type: STATUS_TYPE) => {
  switch (type) {
    case STATUS_TYPE.PARTIAL:
      return styles.partial
    case STATUS_TYPE.DONE:
      return styles.done
    case STATUS_TYPE.ERROR:
      return styles.error
    default:
      return styles.new
  }
}

export const StatusText: FC<Props> = ({ className = '', type, children }) => {
  const rootClassName = cn([
    styles.status,
    getStatusTypeClassName(type),
    className
  ])

  return <div className={rootClassName}>{children}</div>
}
